// extracted by mini-css-extract-plugin
export default {"modal":"LeaveReview_modal__8M39X","leaveReviewContent":"LeaveReview_leaveReviewContent__jVrpI","sameLine":"LeaveReview_sameLine__dTOA1"};